import React, { useCallback, useEffect, useMemo, useRef } from "react";
import "./PortfolioFooter.css";

const MAP_ART = `⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣀⣀⢀⣤⡤⣤⣤⣤⣤⣤⣤⠄⠀⠀⣀⡄⠀⠀⠀⠀⠀⠀⠠⠄⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⣠⣤⣤⣤⣤⣤⣴⣲⣿⣱⡷⠟⣷⣄⠀⣿⣿⡿⢿⡁⠀⠀⠀⢠⣤⣤⠄⣀⣚⣥⣶⣶⣿⣿⣿⣶⣶⣮⣽⣷⣦⣤⣤⣤⣤⣀⡀
⠴⠛⠛⢻⣿⣿⣿⣿⣿⣏⡉⢰⣶⣽⠀⠀⠛⠁⠀⠀⠀⢠⡀⠚⢿⣙⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡟⠛⠉⣟⠃⠀
⠀⠀⠀⢸⣿⣿⣿⣿⣿⣿⣧⣿⣿⢛⡇⠀⠀⠀⠀⠀⠀⠻⣻⣼⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣟⡄⠘⠀⠀
⠀⠀⢠⣿⣿⣿⣿⣿⣿⣿⠟⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⣶⠟⠉⢻⢻⣿⣼⣽⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡿⢻⡉⢰⡀⠀⠀
⠀⠀⠈⣿⣿⣿⠿⠿⢿⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣰⣾⣿⣿⣦⣴⣦⣤⣽⣿⡿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡦⠑⠉⠁⠀⠀
⠀⠀⠀⠀⢻⣯⣀⡄⠘⢄⡀⠀⠀⠀⠀⠀⠀⠀⠀⣰⣿⣿⣿⣿⣿⣿⣿⣿⣎⢿⣿⣶⠆⠈⠻⣿⡿⠛⢿⣿⡟⡟⠑⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠉⠻⣀⣠⣄⣀⡀⠀⠀⠀⠀⠀⠀⠹⣿⣿⣿⣿⣿⣿⣿⣿⣿⣮⣭⠁⠀⠀⠀⠻⡃⠀⠀⡟⠿⠀⠈⢳⡀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⣠⣿⣿⣿⣿⣧⣀⠀⠀⠀⠀⠀⠈⠉⠉⠉⣿⣿⣿⣿⣿⠟⠁⠀⠀⠀⠀⠀⠀⠀⠈⢻⡆⢴⡿⠀⠀⡀⡀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⢹⣿⣿⣿⣿⣿⣿⡿⠂⠀⠀⠀⠀⠀⠀⠀⢹⣿⣿⣿⣿⡄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠑⠒⠀⠠⢀⡈⠙⠳
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠉⢻⣿⣿⣿⣿⡇⠀⠀⠀⠀⠀⠀⠀⠀⢸⣿⣿⣿⡟⢀⡾⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣀⣴⣿⣷⣼⣆
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢸⣿⣿⣿⠃⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⣿⣿⡟⠀⠈⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢸⣿⣿⣿⣿⣿⣿
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢸⣿⡿⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠘⠋⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠚⠙⠉⠘⠿⡟⠋
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⣿⡄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠂⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀`;

const REPEL_RADIUS = 92;
const MAX_PUSH = 90;
const DESKTOP_MIN_WIDTH = 769;

const isMapEmpty = (char) => char === "⠀" || char === " ";

function FooterMapArt() {
  const mapRef = useRef(null);
  const pointsRef = useRef([]);
  const rafRef = useRef(null);

  const rendered = useMemo(() => {
    return MAP_ART.split("\n").map((line, lineIndex) => (
      <span className="portfolio-footer__map-line" key={lineIndex}>
        {[...line].map((char, charIndex) => {
          const empty = isMapEmpty(char);
          const shouldPulse =
            !empty &&
            ((lineIndex * 19 + charIndex * 31) % 47 === 0 ||
              (lineIndex * 11 + charIndex * 17) % 89 === 0);

          return (
            <span
              key={`${lineIndex}-${charIndex}`}
              className={[
                empty
                  ? "portfolio-footer__map-space"
                  : "portfolio-footer__map-char",
                shouldPulse ? "portfolio-footer__map-heartbeat" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              style={
                shouldPulse
                  ? {
                      "--heartbeat-delay": `${((lineIndex + charIndex) % 9) * 0.42}s`,
                      "--heartbeat-speed": `${3.8 + ((lineIndex + charIndex) % 5) * 0.28}s`,
                    }
                  : undefined
              }
            >
              {char}
            </span>
          );
        })}
        {"\n"}
      </span>
    ));
  }, []);

  const resetDots = useCallback(() => {
    pointsRef.current.forEach(({ node }) => {
      node.style.transform = "";
    });
  }, []);

  const measureDots = useCallback(() => {
    const map = mapRef.current;
    if (!map) return;

    resetDots();

    const mapRect = map.getBoundingClientRect();
    const dots = Array.from(map.querySelectorAll(".portfolio-footer__map-char"));

    pointsRef.current = dots.map((node) => {
      const rect = node.getBoundingClientRect();

      return {
        node,
        x: rect.left - mapRect.left + rect.width / 2,
        y: rect.top - mapRect.top + rect.height / 2,
      };
    });
  }, [resetDots]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return undefined;

    const delayedMeasure = window.setTimeout(measureDots, 250);

    if (document.fonts?.ready) {
      document.fonts.ready.then(measureDots).catch(() => {});
    }

    const repelDots = (clientX, clientY) => {
      if (window.innerWidth < DESKTOP_MIN_WIDTH) {
        resetDots();
        return;
      }

      const currentMap = mapRef.current;
      if (!currentMap) return;

      if (!pointsRef.current.length) {
        measureDots();
      }

      const mapRect = currentMap.getBoundingClientRect();

      const outside =
        clientX < mapRect.left - REPEL_RADIUS ||
        clientX > mapRect.right + REPEL_RADIUS ||
        clientY < mapRect.top - REPEL_RADIUS ||
        clientY > mapRect.bottom + REPEL_RADIUS;

      if (outside) {
        resetDots();
        return;
      }

      const mouseX = clientX - mapRect.left;
      const mouseY = clientY - mapRect.top;

      pointsRef.current.forEach(({ node, x, y }) => {
        const dx = x - mouseX;
        const dy = y - mouseY;
        const distance = Math.hypot(dx, dy);

        if (distance > REPEL_RADIUS) {
          node.style.transform = "";
          return;
        }

        const force = Math.pow(1 - distance / REPEL_RADIUS, 2);
        const push = force * MAX_PUSH;
        const safeDistance = Math.max(distance, 1);

        const moveX = (dx / safeDistance) * push;
        const moveY = (dy / safeDistance) * push;

        node.style.transform = `translate3d(${moveX}px, ${moveY}px, 0)`;
      });
    };

    const onPointerMove = (event) => {
      if (rafRef.current) {
        window.cancelAnimationFrame(rafRef.current);
      }

      rafRef.current = window.requestAnimationFrame(() => {
        repelDots(event.clientX, event.clientY);
      });
    };

    const onResize = () => {
      resetDots();
      window.setTimeout(measureDots, 120);
    };

    window.addEventListener("pointermove", onPointerMove, { passive: true });
    window.addEventListener("resize", onResize);

    return () => {
      window.clearTimeout(delayedMeasure);
      window.removeEventListener("pointermove", onPointerMove);
      window.removeEventListener("resize", onResize);

      if (rafRef.current) {
        window.cancelAnimationFrame(rafRef.current);
      }
    };
  }, [measureDots, resetDots]);

  return (
    <pre ref={mapRef} className="portfolio-footer__map-art" aria-hidden="true">
      {rendered}
    </pre>
  );
}

function PortfolioFooter() {
  return (
    <footer className="portfolio-footer" data-pet-footer-platform>
      <div className="portfolio-footer__map-wrap" aria-hidden="true">
        <FooterMapArt />
      </div>

      <div className="portfolio-footer__content">
        <p className="portfolio-footer__quote">
          Every idea is a juxtaposition. That’s it. A juxtaposition of existing concepts.
          <br/>
          — Steven Grant
        </p>

        <nav className="portfolio-footer__nav" aria-label="Footer navigation">
          <ul>
            <li>
              <a href="mailto:ragavkrisnah4535@gmail.com">Email</a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/ragav-krishna-610153287" target="_blank" rel="noreferrer">
                LinkedIn
              </a>
            </li>
            <li>
              <a href="https://medium.com/@ragavkrishna1100" target="_blank" rel="noreferrer">
                Medium
              </a>
            </li>
            <li>
              <a href="https://github.com/Ragav1100" target="_blank" rel="noreferrer">
                GitHub
              </a>
            </li>
          </ul>

          <ul>
            <li>
              <a href="#/featured-projects">Work</a>
            </li>
            <li>
              <a href="#/about">About Me</a>
            </li>
            <li>
              <a href="#/resume" target="_blank">
                Resume
              </a>
            </li>
            <li>
              <a href="#/cards-showcase">
                Character Cards
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}

export default PortfolioFooter;
